import React from 'react';
import { Link , withRouter } from 'react-router-dom';
import SaveButton from '../Buttons/SaveButton/SaveButton';
import styles from './VideoItem.module.css';
const VideoItem = (props)=>{

    return (
        <div className={styles.VideoItem}>
            <Link to={'/' + props.videoLink} className={styles.CoverContainer}>
            <img 
            src={props.cover} 
            alt={props.title + '-' + props.topic}
            className={styles.Cover} />
            <div className={styles.DurationContainer}>
                <h3 className={styles.Duration}>{props.duration.toString().toPersinaDigit()}</h3>
            </div>
            <Link to={'/Course/' + props.topicLink} className={styles.CourseImageContainer}>
                <img src={props.courseImage} className={styles.CourseImage} alt={props.topic}  />
                </Link>
            </Link>
            
            <div className={styles.Controls}>
              
                
                <div className={styles.TitlesContainer}>
                    <Link to={'/' + props.videoLink} className={styles.Title}>{props.title}</Link>
                    <Link 
                    className={styles.Topic}
                    to={'/Course/' + props.topicLink}>
                        {props.topic}</Link>
                </div>
                
              {props.SavedVideo ? <SaveButton isSavedItem isSaved SaveHandler = {props.unSaveHandler}/> : null}
            </div>
        </div>
    )
}

export default withRouter(VideoItem);